<template>
  <div id="passlayout">
    <!-- Popup modal display evaluation history -->
    <transition leave-active-class="duration-200">
      <div
        v-if="num_eval_display > -1"
        class="z-30 fixed bottom-0 inset-x-0 px-4 pb-6 inset-0 p-0 flex items-center justify-center"
      >
        <!-- Background modal -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="num_eval_display > -1"
            class="fixed inset-0 transition-opacity"
            @click="closeHistoryEvaluation()"
          >
            <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
          </div>
        </transition>
        <!-- FIN Background modal -->

        <!-- Content modal -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            :class="'md:px-4 lg:p-6 bg-white rounded-lg pt-5 pb-4 overflow-y-scroll overflow-x-hidden max-h-9/10 shadow-xl transform transition-all xl:w-2/3 w-full'"
            aria-labelledby="modal-headline"
            aria-modal="true"
            role="dialog"
          >
            <action-button
              v-if="
                $can(constants.PERMISSION_NEOPASS_EXPORT) &&
                  typeExportInProgress != 'history'
              "
              class="w-max ml-4 lg:ml-0"
              border-color="border-transparent"
              bg-color="bg-teal-300"
              bg-color-square="bg-teal-100"
              icon-color="text-teal-600"
              text-color="text-gray-900"
              icon="upload"
              libelle="Exporter en PDF"
              @clickAction="
                exporterHistory(true, listEvaluations[num_eval_display])
              "
              :responsive="true"
            />
            <action-button
              v-if="
                $can(constants.PERMISSION_NEOPASS_EXPORT) &&
                  typeExportInProgress == 'history'
              "
              class="w-max ml-4 lg:ml-0"
              border-color="border-transparent"
              bg-color="bg-teal-300"
              bg-color-square="bg-teal-100"
              icon-color="text-teal-600"
              text-color="text-gray-900"
              libelle="Export en cours"
              :spinner="true"
              :responsive="true"
            />
            <div
              class="absolute cursor-pointer right-5 top-5 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
              @click="closeHistoryEvaluation()"
            >
              <icon name="close" />
            </div>
            <div>
              <div class="mx-4 lg:mx-0 mt-5 mb-10">
                <h3 class="">
                  Historique du
                  {{
                    new Date(
                      listEvaluations[num_eval_display].closed_at
                    ).toLocaleDateString()
                  }}
                </h3>
                <h3 class="">
                  "{{
                    listEvaluations[num_eval_display]['data']['template'] ==
                      'ROME'
                      ? 'Fiche ROME'
                      : listEvaluations[num_eval_display].template.name
                  }}"
                </h3>
                <p
                  v-if="$freeParticulier() || $isGuest()"
                  class="text-center text-base"
                >
                  Évaluation faite par
                  {{ evaluatorFullName }}
                </p>
                <p
                  v-else
                  class="text-center text-base"
                >
                  Évaluation faite par
                  {{ evaluator }}
                </p>
              </div>

              <!-- BEGIN Referentiel Multi 1 history -->
              <div
                v-if="
                  ['multi1', 'ref_multi1', 'euro'].includes(
                    contentHistoryEvaluation.type_temp
                  )
                "
                class="flex flex-col justify-center m-5 md:m-15 2xl:m-20"
              >
                <div
                  v-for="(
                    langue, indexLangue
                  ) in contentHistoryEvaluation.items"
                  :key="indexLangue"
                  class="mb-10"
                >
                  <p
                    class="text-base text-indigo-600 uppercase font-normal w-full mb-5"
                  >
                    Langue {{ indexLangue + 1 }} : {{ langue.name }}
                  </p>

                  <div class="grid grid-cols-12 gap-x-4 gap-y-10">
                    <div
                      v-for="(
                        field, jndex
                      ) in contentHistoryEvaluation.template"
                      :key="jndex"
                      class="col-span-full md:col-span-3 flex"
                      :class="{
                        'md:col-start-1': jndex == 1,
                        'md:col-span-4': jndex == 0,
                      }"
                    >
                      <input-text
                        v-if="field.type == 'text' && jndex > 0"
                        :libelle="field.libelle"
                        :value="langue.criterions[jndex]"
                        :disabled="true"
                      />
                      <input-select
                        v-else-if="field.type == 'multi'"
                        :name="
                          field.libelle
                            .toLowerCase()
                            .replace(' ', '_')
                            .replace('\'', '') + indexLangue
                        "
                        :libelle="field.libelle"
                        :value="langue.criterions[jndex]"
                        :datas="field.criterions"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Referentiel Multi 1 history -->

              <!-- BEGIN Referentiel CLEA history -->
              <div
                v-if="
                  ['clea', 'clea_num', 'ref_clea', 'ref_clea_num'].includes(
                    contentHistoryEvaluation.type_temp
                  )
                "
                class="flex flex-col w-full"
              >
                <!-- Extract all language evaluated in "items" -->
                <!-- BEGIN List domaines -->
                <drop-down-list
                  prefix-libelle="Domaine "
                  :current-field="currentField"
                  :options="contentHistoryEvaluation.items"
                  libelle-key-in-options-array="libelle"
                  @chooseItem="
                    (num) => {
                      currentField = num;
                    }
                  "
                />
                <!-- END List domaines -->
                <!-- BEGIN criterions list -->
                <checkboxes-grid
                  v-for="(skill, index) in contentHistoryEvaluation.items[
                    currentField
                  ].skills"
                  :key="index"
                  class="p-0 my-4 md:my-8 md:mx-10"
                  :title="
                    currentField + 1 + '-' + (index + 1) + '. ' + skill.libelle
                  "
                  :list="
                    skill.criterions.reduce(
                      (acc, crit) => ({ ...acc, [crit.value]: crit.check }),
                      {}
                    )
                  "
                  @changeValue="
                    (infos) => {
                      // Determine the key by the libelle (because it is the only value return by the component in this event)
                      var jndex = skill.criterions.reduce(
                        (acc, crit, num) => ({ ...acc, [crit.value]: num }),
                        {}
                      )[infos.key];
                      skill.criterions[jndex].check = infos.value;
                    }
                  "
                />
                <!-- END criterions list -->
              </div>
              <!-- END Referentiel CLEA history -->

              <!-- BEGIN Referentiel Multi 2 history -->
              <div
                v-if="
                  ['multi2', 'ref_multi2'].includes(
                    contentHistoryEvaluation.type_temp
                  )
                "
                class="lg:m-15 2xl:m-20"
              >
                <!-- display as a table -->
                <div
                  v-if="!$isMobile()"
                  class="mt-10"
                >
                  <div
                    class="text-lg text-gray-600 grid grid-cols-11 gap-x-4 content-start h-16 lg:h-24 2xl:h-32"
                  >
                    <div class="mx-10 col-span-1" />
                    <div class="col-span-3">
                      Intitulé
                    </div>
                    <div class="col-span-3 text-left">
                      Auto-évaluation
                    </div>
                    <div class="col-span-3 text-left">
                      Evaluation du référent
                    </div>
                    <div class="col-span-1 pr-4 text-center">
                      Comm.
                    </div>
                  </div>
                  <!-- END line for pictograms -->

                  <div
                    class="even:bg-gray-200 even:bg-opacity-50 grid grid-cols-11 gap-x-4 content-center h-auto py-5 xl:min-h-24 2xl:min-h-32"
                    v-for="(intitule, index) in contentHistoryEvaluation
                      .template[1].criterions"
                    :key="index"
                  >
                    <div
                      class="col-span-1 mx-auto pl-4 w-min-content w-min justify-center flex flex-col"
                    >
                      <info-bulle
                        :name="intitule.libelle"
                        :libelle="intitule.libelle"
                      />
                    </div>
                    <div class="col-span-3 justify-center flex flex-col">
                      <h4 class="text-base font-normal text-left">
                        {{ intitule.description }}
                      </h4>
                    </div>

                    <input-select
                      class="md:col-span-3 md:justify-self-center"
                      :name="index + 'auto_eval'"
                      :datas="contentHistoryEvaluation.template[0].criterions"
                      :value="contentHistoryEvaluation.items[index].autoEval"
                      :disabled="true"
                    />

                    <input-select
                      class="md:col-span-3 justify-self-center"
                      :name="index + 'nouvelle_eval'"
                      :datas="contentHistoryEvaluation.template[0].criterions"
                      :value="
                        contentHistoryEvaluation.items.filter(
                          (item) =>
                            (item.name && item.name === intitule.libelle) ||
                            item.description === intitule.description
                        )[0].refEval
                      "
                      :disabled="true"
                    />

                    <div
                      class="col-span-1 mx-auto pr-4 w-min-content w-min justify-center flex flex-col"
                    >
                      <info-bulle
                        :libelle="
                          contentHistoryEvaluation.items.filter(
                            (item) => item.name === intitule.libelle
                          )[0].comment
                        "
                        :name="
                          contentHistoryEvaluation.items.filter(
                            (item) => item.name === intitule.libelle
                          )[0].name + '_comment'
                        "
                        icon="message-circle"
                        icon-color="text-pink-600"
                        text-color="text-black"
                        background-color="bg-white"
                      />
                    </div>
                  </div>
                </div>
                <!-- END display as a table -->

                <!-- display on rows (for MOBILE devices) -->
                <div v-else>
                  <div
                    v-for="(intitule, index) in contentHistoryEvaluation
                      .template[1].criterions"
                    :key="index"
                    class="odd:bg-indigo-100 odd:bg-opacity-50"
                  >
                    <div
                      class="h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
                      :class="{
                        'bg-indigo-200 border-l-2 border-indigo-600':
                          itemDisplayed == index,
                      }"
                      @click="displayItem(index)"
                      :id="'intitule' + index"
                    >
                      <div
                        class="col-span-2 text-pink-600 justify-self-center flex flex-col justify-around"
                      >
                        <icon
                          class="transform transition-transform ease-in-out duration-300"
                          :class="{ 'rotate-90': itemDisplayed == index }"
                          name="chevron-right"
                        />
                      </div>
                      <div class="col-span-10 text-base line-clamp-3">
                        {{ intitule.libelle }}
                      </div>
                    </div>

                    <transition
                      enter-active-class="ease-out duration-300"
                      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                      leave-active-class="ease-in duration-200"
                      leave-class="opacity-100 translate-y-0 sm:scale-100"
                      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                      <div
                        v-show="itemDisplayed === index"
                        class="bg-white my-5 w-full relative flex flex-col space-y-4 px-5"
                      >
                        <input-text-area
                          libelle="Intitulé"
                          :value="intitule.description"
                          :disabled="true"
                          :size="3"
                        />

                        <input-select
                          :name="index + 'auto_eval'"
                          :disabled="true"
                          :datas="
                            contentHistoryEvaluation.template[0].criterions
                          "
                          :value="
                            contentHistoryEvaluation.items[index].autoEval
                          "
                          libelle="Auto-évaluation"
                          libelle-style="text-base text-indigo-600"
                        />

                        <input-select
                          :name="index + 'nouvelle_eval'"
                          :datas="
                            contentHistoryEvaluation.template[0].criterions
                          "
                          :value="
                            contentHistoryEvaluation.items.filter(
                              (item) =>
                                (item.name && item.name === intitule.libelle) ||
                                item.description === intitule.description
                            )[0].refEval
                          "
                          :disabled="true"
                          libelle="Nouvelle évaluation du référent"
                          libelle-style="text-base text-indigo-600"
                        />

                        <input-text-area
                          :name="
                            contentHistoryEvaluation.items.filter(
                              (item) => item.name === intitule.libelle
                            )[0].name + '_comment'
                          "
                          libelle="Commentaire"
                          :value="
                            contentHistoryEvaluation.items.filter(
                              (item) => item.name === intitule.libelle
                            )[0].comment
                          "
                          :size="3"
                          :disabled="true"
                        />
                      </div>
                    </transition>
                  </div>
                </div>
                <!-- END display on rows (for MOBILE devices) -->
                <input-text-area
                  v-if="
                    contentHistoryEvaluation.template[2] &&
                      contentHistoryEvaluation.template[2].isDisplayed
                  "
                  class="mt-10"
                  name="comment"
                  libelle="Commentaire général"
                  :value="contentHistoryEvaluation.comment"
                  :size="3"
                  :disabled="true"
                />
              </div>
              <!-- END Referentiel Multi 2 history -->

              <!-- BEGIN Referentiel Multi 3 history -->
              <div
                v-else-if="
                  ['multi3', 'ref_multi3'].includes(
                    contentHistoryEvaluation.type_temp
                  )
                "
                class="m-5 md:m-15 2xl:m-20"
              >
                <div
                  v-for="(domaine, index) in contentHistoryEvaluation.template"
                  :key="index"
                  class="mb-10"
                >
                  <div class="uppercase text-indigo-600 text-left text-base">
                    {{ domaine[0].libelle }}
                  </div>
                  <div class="grid grid-cols-12 gap-x-4 gap-y-5">
                    <div
                      v-for="(field, jndex) in domaine"
                      :key="jndex"
                      :class="
                        jndex == 0
                          ? 'display-none'
                          : field.length > 2
                            ? 'md:col-span-3'
                            : 'md:col-span-6'
                      "
                      class="col-span-full"
                    >
                      <div v-if="jndex !== 0 || field.type === 'text-area'">
                        <input-text
                          v-if="field.type == 'text'"
                          :disabled="true"
                          :libelle="field.libelle"
                          :value="
                            contentHistoryEvaluation.items[index].criterions[
                              jndex
                            ]
                          "
                        />
                        <input-text
                          v-if="field.type == 'multi'"
                          :datas="field.criterions"
                          :disabled="true"
                          :libelle="field.libelle"
                          :name="
                            field.libelle.toLowerCase().replace(' ', '_') +
                              index +
                              jndex
                          "
                          :value="
                            contentHistoryEvaluation.items[index].criterions[
                              jndex
                            ]
                          "
                        />
                        <input-text-area
                          v-if="field.type == 'text-area'"
                          :libelle="field.libelle"
                          :name="field.libelle.toLowerCase().replace(' ', '_')"
                          :value="
                            contentHistoryEvaluation.items[index].criterions[
                              jndex
                            ]
                          "
                          disabled="true"
                          size="5"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    !contentHistoryEvaluation.items[
                      contentHistoryEvaluation.items.length - 1
                    ].criterions &&
                      contentHistoryEvaluation.items[
                        contentHistoryEvaluation.items.length - 1
                      ].name === 'Commentaire'
                  "
                >
                  <div
                    class="col-span-full text-indigo-600 uppercase text-base font-normal"
                  >
                    Commentaire
                  </div>
                  <input-text-area
                    :size="5"
                    :name="'commentaire'"
                    :necessary="false"
                    :disabled="true"
                    :value="
                      contentHistoryEvaluation.items.filter(
                        (item) => item.name === 'Commentaire'
                      )[0].value
                    "
                  />
                </div>
              </div>
              <!-- END Referentiel Multi 3 history -->

              <!-- BEGIN Referentiel Professionnel history -->
              <div
                v-if="
                  ['pro', 'ref_pro'].includes(
                    contentHistoryEvaluation.type_temp
                  )
                "
              >
                <h3 class="mb-10 mx-5 md:mx-15 2xl:mx-20">
                  {{
                    this.infosPage.libelle_page +
                      ' : ' +
                      this.contentHistoryEvaluation.name_job
                  }}
                </h3>

                <div v-if="this.contentHistoryEvaluation.items.activities">
                  <div
                    v-if="
                      this.contentHistoryEvaluation.items.activities.length > 0
                    "
                    class="text-lg text-gray-600 grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 place-content-center"
                  >
                    <div
                      class="col-start-3 md:col-start-2 col-span-10 md:col-span-3"
                    >
                      Activité
                    </div>
                    <div
                      class="hidden md:block col-span-5 md:col-span-4"
                      v-if="
                        contentHistoryEvaluation.template.filter(
                          (f) => f.libelle === 'Niveau de maîtrise acquis'
                        )[0].included ||
                          contentHistoryEvaluation.template.filter(
                            (f) => f.libelle === 'Niveau de maîtrise acquis'
                          )[0].included === undefined
                      "
                    >
                      Niveau de maîtrise
                    </div>
                    <div
                      class="hidden md:block col-span-4"
                      v-if="
                        contentHistoryEvaluation.template.filter(
                          (f) => f.libelle === 'Temps consacré'
                        )[0].included ||
                          contentHistoryEvaluation.template.filter(
                            (f) => f.libelle === 'Temps consacré'
                          )[0].included === undefined
                      "
                    >
                      Temps consacré
                    </div>
                  </div>

                  <!-- BEGIN list of histories -->
                  <div
                    v-for="(activity, num) in this.contentHistoryEvaluation
                      .items.activities"
                    :key="num"
                    class="odd:bg-indigo-100 odd:bg-opacity-50"
                  >
                    <!-- BEGIN Informations on accordion -->
                    <div
                      :class="{
                        'bg-indigo-200 border-l-2 border-indigo-600':
                          itemDisplayed == num,
                      }"
                      class="h-auto py-5 xl:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
                      @click="displayItem(num)"
                      :id="'item' + num"
                    >
                      <div
                        class="col-span-2 md:col-span-1 text-pink-600 place-self-center"
                      >
                        <icon
                          :class="{ 'rotate-90': itemDisplayed == num }"
                          class="inline-block transform transition-transform ease-in-out duration-300"
                          name="chevron-right"
                        />
                      </div>
                      <div
                        class="col-span-10 md:col-span-3 text-base place-self-center justify-self-start"
                      >
                        <span>{{ activity.libelle }}</span>
                      </div>
                      <div
                        v-if="
                          contentHistoryEvaluation.template.filter(
                            (f) => f.libelle === 'Niveau de maîtrise acquis'
                          )[0].included ||
                            contentHistoryEvaluation.template.filter(
                              (f) => f.libelle === 'Niveau de maîtrise acquis'
                            )[0].included === undefined
                        "
                        class="hidden md:block col-span-5 md:col-span-4 place-self-center justify-self-start text-base"
                      >
                        <span
                          v-if="
                            activity.general.filter((gen) =>
                              gen.name.includes('acquis')
                            ).length > 0 &&
                              (activity.general.filter((gen) =>
                                gen.name.includes('acquis')
                              )[0].value !== '' ||
                                activity.general.filter((gen) =>
                                  gen.name.includes('acquis')
                                )[0].value !== undefined ||
                                activity.general.filter((gen) =>
                                  gen.name.includes('acquis')
                                )[0].value !== null ||
                                activity.general.filter((gen) =>
                                  gen.name.includes('acquis')
                                )[0].value !== [])
                          "
                        >
                          {{
                            activity.general.filter((gen) =>
                              gen.name.includes('acquis')
                            )[0].value
                          }}
                        </span>
                      </div>
                      <div
                        v-if="
                          contentHistoryEvaluation.template.filter(
                            (f) => f.libelle === 'Temps consacré'
                          )[0].included ||
                            contentHistoryEvaluation.template.filter(
                              (f) => f.libelle === 'Temps consacré'
                            )[0].included === undefined
                        "
                        class="hidden md:block col-span-4 place-self-center justify-self-start italic text-base"
                      >
                        <span
                          v-if="
                            activity.general.filter((gen) =>
                              gen.name.includes('Temps')
                            ).length > 0 &&
                              (activity.general.filter((gen) =>
                                gen.name.includes('Temps')
                              )[0].value !== '' ||
                                activity.general.filter((gen) =>
                                  gen.name.includes('Temps')
                                )[0].value !== undefined ||
                                activity.general.filter((gen) =>
                                  gen.name.includes('Temps')
                                )[0].value !== null ||
                                activity.general.filter((gen) =>
                                  gen.name.includes('Temps')
                                )[0].value !== [])
                          "
                        >
                          {{
                            activity.general.filter((gen) =>
                              gen.name.includes('Temps')
                            )[0].value
                          }}
                        </span>
                      </div>
                    </div>
                    <transition
                      enter-active-class="ease-out duration-300"
                      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                      leave-active-class="ease-in duration-200"
                      leave-class="opacity-100 translate-y-0 sm:scale-100"
                      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                      <!-- END Content modal -->
                      <div
                        v-if="itemDisplayed === num"
                        class="py-5 md:p-10 bg-white"
                      >
                        <div
                          class="grid grid-cols-4 gap-4 content-center px-5 mb-10"
                        >
                          <div
                            v-for="(general, index) in activity.general.filter(
                              (g) =>
                                ![
                                  'Critères d\'évaluation',
                                  'Critères',
                                ].includes(g.name) &&
                                (contentHistoryEvaluation.template.filter(
                                  (t) => g.name === t.libelle
                                )[0].included ||
                                  contentHistoryEvaluation.template.filter(
                                    (t) => g.name === t.libelle
                                  )[0].included === undefined)
                            )"
                            :key="index"
                            class="col-span-full md:col-span-1"
                          >
                            <input-text
                              :disabled="true"
                              :name="general.name.replace('\'', '')"
                              :libelle="general.name"
                              :value="general.value"
                            />
                          </div>
                        </div>

                        <activity-category
                          :category="activity.activity_tasks"
                          name="activity_tasks"
                          :id-pass="infosPass.id_pass"
                          :id-user="user.id"
                          :num="num"
                          :form="contentHistoryEvaluation"
                          :history-mode="true"
                        />

                        <activity-category
                          :category="activity.activity_pratiques_pros"
                          name="activity_pratiques_pros"
                          :id-pass="infosPass.id_pass"
                          :id-user="user.id"
                          :num="num"
                          :form="contentHistoryEvaluation"
                          :history-mode="true"
                        />

                        <activity-category
                          :category="activity.activity_connaissances"
                          name="activity_connaissances"
                          :id-pass="infosPass.id_pass"
                          :id-user="user.id"
                          :num="num"
                          :form="contentHistoryEvaluation"
                          :history-mode="true"
                        />
                      </div>
                    </transition>
                  </div>
                  <!-- END list of histories -->
                </div>
              </div>
              <!-- BEGIN Referentiel Professionnel history -->

              <!-- BEGIN Référentiel Fiche code ROME -->
              <div
                v-if="
                  (contentHistoryEvaluation.items.competences_bases ||
                    contentHistoryEvaluation.items.competences_spe) &&
                    contentHistoryEvaluation.template === 'ROME'
                "
              >
                <evaluation-rome
                  :form="contentHistoryEvaluation"
                  :is-disabled="true"
                  :history-mode="true"
                />
              </div>
              <!-- END Référentiel Fiche code ROME -->

              <!-- BEGIN Referentiel Scolaire history -->
              <div
                v-if="
                  ['sco', 'ref_sco'].includes(
                    contentHistoryEvaluation.type_temp
                  )
                "
                class="m-5 md:m-15 2xl:m-20"
              >
                <h3 class="mb-10">
                  {{
                    this.infosPage.libelle_page +
                      ' : ' +
                      this.contentHistoryEvaluation.name_job
                  }}
                </h3>

                <div
                  v-if="this.contentHistoryEvaluation.items.modules.length > 0"
                  class="text-lg text-gray-600 grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 place-content-center"
                >
                  <div
                    class="col-start-3 md:col-start-2 col-span-10 md:col-span-7"
                  >
                    Domaine
                  </div>
                  <div class="hidden md:block col-span-4">
                    Temps consacré
                  </div>
                </div>

                <!-- Line break to make space between header and list of parcours -->
                <div class="w-full" />
                <!-- BEGIN list of parcours -->
                <div
                  v-for="(mod, num) in this.contentHistoryEvaluation.items
                    .modules"
                  :key="num"
                  class="odd:bg-indigo-100 odd:bg-opacity-50"
                >
                  <!-- BEGIN Informations on accordion -->
                  <div
                    :class="{
                      'bg-indigo-200 border-l-2 border-indigo-600':
                        itemDisplayed == num,
                    }"
                    class="h-auto py-5 min-h-16 xl:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 place-content-center"
                    @click="displayItem(num)"
                    :id="'item' + num"
                  >
                    <div
                      class="col-span-2 md:col-span-1 text-pink-600 place-self-center"
                    >
                      <icon
                        :class="{ 'rotate-90': itemDisplayed == num }"
                        class="inline-block transform transition-transform ease-in-out duration-300"
                        name="chevron-right"
                      />
                    </div>
                    <div
                      class="col-span-10 md:col-span-7 text-base place-self-center justify-self-start"
                    >
                      <span>{{ mod.libelle }}</span>
                    </div>
                    <div
                      class="hidden md:block col-span-4 place-self-center justify-self-start text-base"
                    >
                      <span
                        v-if="
                          mod.general[0].value !== '' ||
                            mod.general[0].value !== undefined ||
                            mod.general[0].value !== null
                        "
                      >
                        {{ mod.general[0].value }}
                      </span>
                    </div>
                  </div>
                  <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <!-- END Content modal -->
                    <div
                      v-if="itemDisplayed == num"
                      class="p-5 bg-white"
                    >
                      <div
                        class="grid grid-cols-2 gap-4 content-center md:gap-y-10 mb-15"
                      >
                        <div
                          v-for="(gen, index) in mod.general"
                          :key="index"
                          class="col-span-full md:col-span-1"
                        >
                          <input-text
                            :disabled="true"
                            :name="gen.name.replace('\'', '')"
                            :libelle="gen.name"
                            :value="gen.value == null ? '' : gen.value"
                          />
                        </div>
                      </div>

                      <module-category
                        :datas="mod.module_competences"
                        :form="
                          contentHistoryEvaluation.items.modules[num]
                            .module_competences
                        "
                        :list-criterions="
                          contentHistoryEvaluation.template.filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions
                        "
                        name="module_competences"
                        :id-pass="infosPass.id_pass"
                        :id-user="user.id"
                        :history-mode="true"
                      />

                      <module-category
                        :datas="mod.module_competences_transversales"
                        :form="
                          contentHistoryEvaluation.items.modules[num]
                            .module_competences_transversales
                        "
                        :list-criterions="
                          contentHistoryEvaluation.template.filter(
                            (temp) => temp.libelle === 'Critères d\'évaluation'
                          )[0].criterions
                        "
                        name="module_competences_transversales"
                        :id-pass="infosPass.id_pass"
                        :id-user="user.id"
                        :history-mode="true"
                      />
                    </div>
                  </transition>
                </div>
              </div>
              <!-- BEGIN Referentiel Scolaire history -->
            </div>
          </div>
        </transition>
        <!-- END Content modal -->
      </div>
    </transition>
    <!-- END Popup modal display evaluation history -->

    <!-- BEGIN Popup intervertir postes -->
    <popup
      :opened="swap || false"
      @close="swap = false"
    >
      <div
        v-if="postes.length > 0"
        class="m-10"
      >
        <h3 class="mb-10">
          Intervertir les
          {{
            structure && structure.type === constants.TYPE_OF
              ? 'référentiels'
              : 'postes'
          }}
        </h3>
        <h6 class="text-indigo-600 mb-10">
          Sélectionnez les
          {{
            structure && structure.type === constants.TYPE_OF
              ? 'référentiels'
              : 'postes'
          }}
          dont vous souhaitez intervertir l'ordre.
        </h6>
        <div class="flex flex-col justify-center items-center">
          <input-select
            :datas="postes"
            :necessary="false"
            class="md:w-1/3 mb-5"
            libelle="Intervertir"
            name="poste_1"
            @input="
              (newValue) => {
                poste1 = postes.find((p) => p.value === newValue).id;
              }
            "
            :empty-case="false"
          />

          <input-select
            :datas="postes"
            :necessary="false"
            class="md:w-1/3 mb-10"
            libelle="Avec"
            name="poste_2"
            @input="
              (newValue) => {
                poste2 = postes.find((p) => p.value === newValue).id;
              }
            "
            :empty-case="false"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="w-max"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            border-color="border-transparent"
            icon="arrow-right_1"
            icon-color="text-white"
            libelle="CONTINUER"
            :uppercase="true"
            text-color="text-white"
            type-shadow="shadow-pink"
            :right="true"
            @clickAction="swapJobs()"
          />
        </div>
      </div>
      <div
        v-else
        class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
      >
        <h3 class="w-full text-gray-900 mb-10">
          Intervertir les
          {{
            structure && structure.type === constants.TYPE_OF
              ? 'référentiels'
              : 'postes'
          }}
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Vous n’avez pas encore de
            {{
              structure && structure.type === constants.TYPE_OF
                ? 'référentiel'
                : 'poste'
            }}
            créé. <br />Veuillez choisir
            {{
              structure && structure.type === constants.TYPE_OF
                ? 'un référentiel de formation'
                : ' une fiche de poste'
            }}
            pour vos différents
            {{
              structure && structure.type === constants.TYPE_OF
                ? 'référentiels'
                : 'postes'
            }}
            <br />afin de les intervertir par la suite.
          </p>
        </div>

        <illustration
          class="w-full"
          name="notAllowed"
        />
      </div>
    </popup>
    <!-- END Popup intervertir postes -->

    <!-- Popup frise chronologie -->
    <popup-frise
      :opened="showFriseChronologique || false"
      @close="showFriseChronologique = false"
    />
    <!-- END Popup frise chronologique -->

    <popup
      :opened="restrictedHistoryPopup"
      @close="restrictedHistoryPopup = false"
    >
      <div class="my-4 mx-6">
        <p>
          Pour visualiser l'ensemble de vos historiques,
          <router-link
            :to="{ name: 'Subscriptionchoice' }"
            class="underline text-indigo-600"
          >
            faites évoluer votre abonnement.
          </router-link>
        </p>
      </div>
    </popup>

    <div
      class="hidden relative md:flex items-center bg-indigo-200 overflow-visible rounded-sm h-40 md:h-48 w-full top-5 md:mt-0"
    >
      <div class="px-12 cursor-default w-full">
        <p class="text-4xl text-gray-900">
          {{ infosPass.name }}
        </p>
        <!-- BEGIN Ariane Wire -->
        <div class="inline-flex flex-col xxl:flex-row flex-wrap w-3/4">
          <div class="flex font-light text-gray-900 space-x-1">
            <icon name="building" />
            <div>
              {{
                $freeParticulier() || $isGuest()
                  ? infosPass.name
                  : structure.name
              }}
            </div>
            <span
              v-if="allowed"
              class="hidden xxl:inline-block"
            >>&nbsp;</span>
          </div>
          <div
            v-if="allowed && !$isGuest"
            class="text-indigo-600 inline-flex font-light space-x-1"
          >
            <icon name="layers" />
            <router-link :to="{ name: 'Neopass' }">
              &nbsp;{{
                role === constants.ROLE_BENEFICIAIRE || $freeParticulier()
                  ? 'Mon carnet'
                  : 'Mes carnets'
              }}
              de parcours&nbsp;
            </router-link>
            <span class="hidden xxl:inline-block">>&nbsp;</span>
          </div>
          <span
            v-if="allowed"
            class="text-pink-600 font-light space-x-1"
          >
            {{ infosPage.libelle_module }}
            <span
              v-if="getLibelle({ infosPage })"
              class="hidden xxl:inline-block"
            >>&nbsp;</span>
          </span>
          <span
            v-if="allowed"
            class="inline-block text-gray-600 font-light space-x-1"
          >
            {{ getLibelle({ infosPage }) ? getLibelle({ infosPage }) : '' }}
          </span>
        </div>
        <!-- END Ariane Wire -->
      </div>
      <illustration
        class="hidden md:block absolute right-5 xl:right-10 w-60 xl:w-72"
        name="Group189"
      />
    </div>

    <div v-if="allowed">
      <div class="md:hidden text-3xl mb-5">
        {{ infosPass.name }}
      </div>

      <!-- BEGIN List Buttons action -->
      <list-action-buttons
        class="my-5 md:mt-16 md:mb-10"
        :list-modules-pages="listModulesPages"
        :can-swap="canSwap"
        :module-name="moduleName"
        :list-modules-pages-to-export="listModulesPagesToExport"
        :unique-jobs="uniqueJobs"
        :jobs="jobs"
        :infos-pass="infosPass"
        @displaySwap="displaySwapPopup"
        @displayFriseChronologique="displayFriseChronologique"
      />
      <!-- END List Buttons action -->

      <!-- Progress bar -->
      <progress-bar
        class="tour_progress_bar"
        v-if="infosPage.progress_bar"
        ref="progressBar"
      />
      <!-- End Progress bar -->

      <!-- BEGIN Message header -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-if="
            messageHeader != '' ||
              (messageHeader.msg &&
                messageHeader.type &&
                messageHeader.type != '' &&
                messageHeader.msg != '')
          "
          class="sticky top-0 z-10"
        >
          <div
            :class="{
              'bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600':
                messageHeader == 'saveIsSuccess',
              'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600':
                messageHeader == 'saveNotAllowed' || messageHeader == 'error',
              'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600':
                messageHeader.type == 'INPUT' || messageHeader == 'noContent',
            }"
            class="absolute text-center p-2 w-10/12 left-1/12 right-1/12 mt-15 md:p-5 md:mt-10 md:w-6/12 md:left-3/12 md:right-3/12 text-lg flex items-center justify-center"
          >
            <div>
              <div class="flex items-center justify-center">
                <icon
                  v-if="messageHeader == 'saveIsSuccess'"
                  class="inline-block mr-2"
                  name="checkmark-circle-2"
                />
                <icon
                  v-else-if="
                    messageHeader == 'saveNotAllowed' ||
                      messageHeader == 'error'
                  "
                  class="inline-block mr-2"
                  name="alert-triangle"
                />
                <icon
                  v-else-if="
                    messageHeader.type == 'INPUT' ||
                      messageHeader == 'noContent'
                  "
                  class="inline-block mr-2"
                  name="alert-circle"
                />

                <div v-if="messageHeader == 'saveIsSuccess'">
                  Vos données ont été enregistrées.
                </div>
                <div v-if="messageHeader == 'error'">
                  Erreur d'enregistrement des données.
                </div>
                <div v-if="messageHeader == 'saveNotAllowed'">
                  Vous n'êtes pas autorisé à éditer cette page.
                </div>
                <div v-if="messageHeader == 'noContent'">
                  Il n'y a aucun contenu à enregistrer ici.
                </div>
                <div v-if="messageHeader.type == 'INPUT'">
                  {{ messageHeader.msg }}
                </div>
              </div>
              <div
                v-if="messageHeader.type === 'INPUT'"
                class="mt-5"
              >
                <button
                  v-if="messageHeader.type == 'INPUT'"
                  class="border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md text-lg p-2 mr-4 transform hover:scale-110 duration-300"
                  @click="cancel_nosave()"
                >
                  ANNULER
                </button>

                <button
                  v-if="messageHeader.type == 'INPUT'"
                  class="bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md text-lg p-2 transform hover:scale-110 duration-300"
                  @click="quit_nosave()"
                >
                  QUITTER
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- END Message header -->

      <!-- Contenu -->
      <div
        class="relative flex flex-col align-middle min-w-full shadow rounded-xl border-b border-gray-200 bg-white pb-10 min-h-halfscreen"
      >
        <div class="sticky z-10 top-48 md:top-0 bg-black">
          <div
            v-if="hasSaveButton"
            id="tour_save_datas"
            class="absolute flex items-center justify-center cursor-pointer bg-pink-600 shadow-pink hover:shadow-outline-pink text-white z-0 w-14 h-14 rounded-full md:right-15 md:mt-10 ml-5/12 md:ml-0 top-96 md:top-0"
            @click="save_datas($refs.neopassForm.form)"
          >
            <icon
              class="h-6 w-6"
              name="save"
            />

            <div
              id="tempSaveBtn"
              class="absolute hidden top-0 rounded-full cursor-pointer bg-pink-600 shadow-pink hover:shadow-outline-pink text-white w-14 h-14 -z-1"
            />
          </div>
        </div>

        <div class="sticky z-10 top-48 mt-22 md:top-22 bg-black">
          <div
            v-if="user.username === 'cdemo'"
            id="tour_save_datas"
            class="absolute flex items-center justify-center cursor-pointer bg-orange-600 shadow-pink hover:shadow-outline-pink text-white z-0 w-14 h-14 rounded-full md:right-15 md:mt-10 ml-5/12 md:ml-0 top-96 md:top-0"
            @click="fillEval()"
          >
            <icon
              class="h-6 w-6"
              name="puzzle"
            />

            <div
              id="tempSaveBtn"
              class="absolute hidden top-0 rounded-full cursor-pointer bg-pink-600 shadow-pink hover:shadow-outline-pink text-white w-14 h-14 -z-1"
            />
          </div>
        </div>

        <div
          v-if="
            !$can(pageName + '_edit', idNeopass) &&
              pageName !== constants.PAGE_NEOPASS_FORM_DOCUMENTS &&
              !$freeParticulier()
          "
          class="text-center text-base text-pink-600 mt-15"
        >
          Vous n'avez pas les droits pour éditer cette page, vous pouvez
          uniquement la consulter
        </div>
        <router-view
          :progressbar="$refs.progressBar"
          ref="neopassForm"
          @reloadPostes="initCompetencesPro()"
        />
      </div>
      <!-- Fin Contenu -->

      <!-- BEGIN History -->
      <div
        v-if="list_evaluation_pages.includes(infosPage.id_page)"
        class="flex flex-col mt-8 md:mt-16"
      >
        <div class="-my-2 py-2">
          <div
            class="relative align-middle min-w-full shadow rounded-xl border-b border-gray-200 bg-white pb-10 table"
          >
            <h3 class="my-10 w-full">
              Historique des évaluations
            </h3>

            <div
              v-if="listEvaluations.length > 0"
              class="text-lg text-gray-600 h-16 md:h-24 2xl:h-32 grid grid-cols-12 gap-x-4 place-content-center"
            >
              <div class="col-start-3 md:col-start-2 col-span-4 md:col-span-2">
                Date de clôture
              </div>
              <div class="col-span-6 md:col-span-3">
                Période
              </div>
              <div class="hidden md:block col-span-3">
                Evaluateur
              </div>
              <div class="hidden md:block col-span-3">
                Aperçu
              </div>
            </div>
            <div v-else>
              <h6 class="text-indigo-600 mb-12">
                Il n'y a pas encore d'évaluation historisée, <br />commencez
                votre première évaluation ci-dessus.
              </h6>
              <div class="flex justify-center">
                <illustration name="notAllowed" />
              </div>
            </div>
            <EvaluationListItem
              v-for="(evaluation, index) in listEvaluations"
              :key="evaluation.id"
              :evaluation="evaluation"
              :disabled="!$subscribed() && index >= 2"
              @click.native="
                !$subscribed() && index >= 2
                  ? showRestrictedHistoryPopup()
                  : displayEvaluation(index)
              "
            />
          </div>
        </div>
      </div>
      <!-- END History -->
    </div>
    <page-not-allowed
      :hostname="role == constants.ROLE_INVITE ? infosPass.name : null"
      v-else
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ActionButton from '../../components/ActionButton';
import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import Popup from '../../components/Popup';
import InputTextArea from '../../components/Inputs/InputTextArea';
import InputText from '../../components/Inputs/InputText';

import axios from 'axios';
import store from '../../store';
import InputSelect from '../../components/Inputs/InputSelect.vue';
import router from '../../router';

import PageNotAllowed from '../../components/PageNotAllowed';
import ClickOutside from 'vue-click-outside';
import EvaluationListItem from '../../components/Evaluations/EvaluationListItem';
import Layout from '../../mixins/Layout';

import Constants from './../../constants';
import InfoBulle from '../../components/InfoBulle';
import JsFileDownload from 'js-file-download';

import ModuleCategory from './../../components/CompetencesPro/ModuleCategory';
import ActivityCategory from './../../components/CompetencesPro/ActivityCategory';

import PopupFrise from '../../components/FriseChronologique/Popup';
import ProgressBar from '../../components/ProgressBar';
import DropDownList from '../../components/DropDownList.vue';
import CheckboxesGrid from '../../components/CheckboxesGrid.vue';

import EvaluationRome from '../../components/CompetencesPro/EvaluationRome.vue';
import ListActionButtons from '../../components/NeopassForm/ListActionButtons.vue';

export default {
  components: {
    ProgressBar,
    InfoBulle,
    EvaluationListItem,
    ActionButton,
    Icon,
    Illustration,
    InputSelect,
    InputText,
    Popup,
    PageNotAllowed,
    InputTextArea,
    PopupFrise,
    ModuleCategory,
    ActivityCategory,
    ListActionButtons,
    DropDownList,
    CheckboxesGrid,
    EvaluationRome,
  },

  mixins: [Layout],

  name: 'NeopassLayout',

  data() {
    return {
      restrictedHistoryPopup: false,
      //List of page where there are evaluation history
      num_eval_display: -1,
      showList: false,
      currentField: 0,
      itemDisplayed: -1,
      swap: false,
      postes: [],
      poste1: '',
      poste2: '',
      constants: Constants,
      showFriseChronologique: false,
      typeExportInProgress: '',
      saveInterval: null,
    };
  },

  created() {
    //this.getPostes(); // necessary to load postes in swap popup
    if (parseInt(this.infosPass.id_pass) === this.user.id) {
      this.saveInterval = setInterval(this.autoSave, 30000);
    }
  },

  mounted() {
    /* var element = document.getElementById("passlayout");
            element.scrollIntoView(true); */
  },

  updated() {
    //When page reload without passing by new route (ex : when already be in neopass form and click on Carnet de parcours for a beneficiary)
    //
  },

  methods: {
    showRestrictedHistoryPopup() {
      this.restrictedHistoryPopup = !this.restrictedHistoryPopup;
    },

    fillEval() {
      console.log(this.$refs.neopassForm.form);
      const getRandomIndex = function (length) {
        return Math.floor(Math.random() * length);
      };

      if (this.$refs.neopassForm.form.type_temp === 'multi2') {
        const criterions = this.$refs.neopassForm.form.template
          .filter((field) => field.libelle === 'Critères d\'évaluation')[0]
          .criterions.map((criterion) => criterion.value);

        const critAmount = criterions.length;

        this.$refs.neopassForm.form.items.forEach((item) => {
          item.autoEval = criterions[getRandomIndex(critAmount)];
          item.refEval = criterions[getRandomIndex(critAmount)];
        });
      } else if (this.$refs.neopassForm.form.type_temp === 'pro') {
        const criterions = this.$refs.neopassForm.form.template
          .filter((field) => field.libelle === 'Critères d\'évaluation')[0]
          .criterions.map((criterion) => criterion.value);

        const critAmount = criterions.length;

        this.$refs.neopassForm.form.items.activities.forEach((activity) => {
          const keys = [
            'activity_comportements',
            'activity_connaissances',
            'activity_pratiques_pros',
            'activity_tasks',
          ];
          for (const key of keys) {
            activity[key].forEach((a) => {
              a.auto = criterions[getRandomIndex(critAmount)];
              a.value = criterions[getRandomIndex(critAmount)];
            });
          }
        });
        this.$refs.neopassForm.hiddenFields.auto_activity_tasks = false;
        this.$refs.neopassForm.hiddenFields.auto_activity_tasks = true;
        this.$refs.neopassForm.$forceUpdate();
      } else {
        this.$refs.neopassForm.form.items.forEach((item) => {
          const label = item.name;
          if (label !== 'Commentaire') {
            const criterions = this.$refs.neopassForm.form.template
              .filter((field) => field[0].libelle === label)[0][1]
              .criterions.map((criterion) => criterion.value);

            item.criterions[1] = criterions[getRandomIndex(criterions.length)];
          }
        });
        this.$refs.neopassForm.$forceUpdate();
      }
    },

    autoSave() {
      if (
        this.canAutoSave &&
        this.hasSaveButton &&
        this.$refs?.neopassForm?.form
      ) {
        this.save_silent(this.$refs?.neopassForm?.form);
      }

      if (!this.canAutoSave) {
        this.SET_CANAUTOSAVE(true);
      }
    },

    ...mapActions({
      save_datas: 'neopass/save_datas',
      save_silent: 'neopass/save_silent',
      load_evaluations: 'neopass/load_evaluations',
      load_datas: 'neopass/load_datas',
      loadFriseDatas: 'neopass/loadFriseDatas',
      getJob: 'neopass/getJob',
      loadJobs: 'neopass/loadJobs',
      load_infos_job: 'neopass/load_infos_job',
    }),

    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
      SET_INFOSPAGE: 'neopass/SET_INFOSPAGE',
      SET_CANAUTOSAVE: 'neopass/SET_CANAUTOSAVE',
      SET_JOBS: 'neopass/SET_JOBS',
      SET_JOB: 'neopass/SET_JOB',
      SET_JOBFORM: 'neopass/SET_JOBFORM',
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
    }),

    displayDropdownMenu() {
      this.dropDownMenu = !this.dropDownMenu;
    },

    addPage(name) {
      this.form.listPage.push(name);
    },

    async initCompetencesPro() {
      console.log('wait...load_jobs');
      await this.getJob();
      await this.loadJobs();
      await this.getPostes();
    },

    async swapJobs() {
      this.SET_LOADING(true);
      await axios
        .get(
          '/api/work_station/swap/' +
            this.infosPass.id_pass +
            '/' +
            (this.poste1 + 1) +
            '/' +
            (this.poste2 + 1)
        )
        .then(async (response) => {
          this.swap = false;
          await this.getJob();
          await this.loadJobs();
          await this.load_infos_job();
          await this.load_datas().then(() =>
            this.$refs?.neopassForm?.initForm()
          );
          await this.loadJobs();
          await this.load_evaluations();
          await this.getPostes();

          this.SET_LOADING(false);
        })
        .catch((error) => {
          console.log('ERRR::', error.response.data);
          this.SET_LOADING(false);
        });
    },

    async displaySwapPopup() {
      await this.getPostes();
      this.swap = true;
    },

    async getPostes() {
      this.postes = [];
      this.listModulesPages
        .find(
          (m) =>
            m.name ===
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES ||
            m.name === Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES
        )
        .pages.forEach((p, index) => {
          this.postes.push({
            value:
              p.display_name +
              ' : ' +
              (this.jobs[index]?.sheet?.name
                ? this.jobs[index]?.sheet?.name
                : 'sans ' +
                  (this.structure && this.structure.type === Constants.TYPE_OF
                    ? 'référentiel'
                    : 'fiche de poste')),
            id: index,
          });
        });
    },

    displayItem(numItem) {
      if (this.itemDisplayed == numItem) {
        this.itemDisplayed = -1;
      } else {
        this.itemDisplayed = numItem;
        let pos = document.getElementById('item' + numItem);
        setTimeout(() => {
          pos.scrollIntoView({ block: 'start' });
        }, 300);
      }
    },

    displayEvaluation(index) {
      this.num_eval_display = index;
    },

    displayFieldList() {
      this.showList = !this.showList;
    },

    quit_nosave() {
      this.infosPage.isFormChanged = false;
      router.push(this.messageHeader.url.url);
      store.commit('neopass/SET_MESSAGEHEADER', { type: '', msg: '' });
    },

    cancel_nosave() {
      store.commit('neopass/SET_MESSAGEHEADER', { type: '', msg: '' });
    },

    closeHistoryEvaluation() {
      this.num_eval_display = -1;
      this.itemDisplayed = -1;
    },

    async exporterHistory(isDownload, evaluation) {
      this.SET_LOADING(true);
      let idPass = this.infosPass.id_pass;

      this.typeExportInProgress = 'history';
      this.errorExportPdf = '';

      await axios({
        url: '/api/pdf/history/' + idPass + '/' + evaluation.id,
        method: 'GET',
        responseType: 'blob', // Important
      })
        .then((response) => {
          let filename = `Evaluation ${evaluation.data.name_temp} du ${evaluation.data.date_debut_evaluation} au ${evaluation.data.date_fin_evaluation}.pdf`;

          if (isDownload) {
            JsFileDownload(response.data, filename);
          } else {
            window.open(URL.createObjectURL(response.data));
          }

          this.typeExportInProgress = '';
          this.SET_LOADING(false);
        })
        .catch((error) => {
          this.typeExportInProgress = '';
          this.errorExportPdf =
            'Une erreur est survenue lors de l\'export des données en PDF. Veuillez contacter le service technique pour régler ce problème.';
          console.log('ERRRR:: ', error);
          this.SET_LOADING(false);
        });
    },

    displayFriseChronologique() {
      Promise.all([this.loadFriseDatas()])
        .then(() => {
          this.showFriseChronologique = true;
        })
        .catch((error) => {
          console.error(`Error while frise chronologique: ${error}`);
        });
    },
  },

  computed: {
    ...mapGetters({
      listModulesPages: 'neopass/listModulesPages',
      friseDatas: 'neopass/friseDatas',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      messageHeader: 'neopass/messageHeader',
      loading: 'neopass/loading',
      listEvaluations: 'neopass/listEvaluations',
      formContent: 'neopass/formContent',
      allowed: 'app/allowed',
      role: 'auth/role',
      user: 'auth/user',
      userJobs: 'jobs/userJobs',
      structure: 'auth/structure',
      canAutoSave: 'neopass/canAutoSave',
      jobs: 'neopass/jobs',
      job: 'neopass/job',
      jobForm: 'neopass/jobForm',
    }),

    list_evaluation_pages() {
      let evaluationPages = this.listModulesPages.reduce(
        (acc, module) => [...acc, ...module.pages],
        []
      );

      return evaluationPages
        .filter((page) => Constants.LIST_EVALUATION_PAGES.includes(page.name))
        .map((page) => page.id);
    },

    hasSaveButton() {
      return (
        this.$can(this.pageName + '_edit', this.idNeopass) &&
        this.moduleName != Constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS &&
        this.pageName != Constants.PAGE_NEOPASS_FORM_PORTFOLIO
      );
    },

    uniqueJobs() {
      let uniqueJobs = [];

      const noEmptyJobs = (job) => {
        return Object.keys(job).length > 0;
      };

      let localJobs = this.jobs.filter(noEmptyJobs); //filter out empty objects
      let jobIds = localJobs.map((job) => job.template_id);
      let uniqueJobIds = [...new Set(jobIds)];

      uniqueJobIds.forEach((id) => {
        uniqueJobs.push(localJobs.filter((job) => job.template_id === id)[0]);
      });
      return uniqueJobs;
    },

    infosURL() {
      /*
       * 0 : id pass
       * 1 : module name
       * 2 : page name
       */
      return ((this.$route.path.split('/form/neopass/') || [])[1] || '').split(
        '/'
      );
    },

    idNeopass() {
      return this.infosURL[0];
    },

    moduleName() {
      return this.infosURL[1];
    },

    pageName() {
      return this.infosURL[2];
    },

    contentHistoryEvaluation() {
      if (this.listEvaluations[this.num_eval_display]) {
        let referent = [
          ...(this.listEvaluations[this.num_eval_display].managers?.map(
            (m) => m?.manager ?? {}
          ) || []),
          ...(this.listEvaluations[this.num_eval_display].admins || []),
          ...(this.listEvaluations[this.num_eval_display].guests || []),
        ];

        return {
          ...this.listEvaluations[this.num_eval_display].data,
          referent: referent[0],
          type_temp: this.listEvaluations[this.num_eval_display].template.type,
        };
      }
    },

    listModulesPagesToExport() {
      return this.listModulesPages.filter(
        (m) => m.name != Constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
      );
    },

    // indicate if auth user can swap "fiches de poste" or "referentiels" in Compétences pro
    canSwap() {
      const isBeneficiary = this.role === Constants.ROLE_BENEFICIAIRE;
      const compPro =
        this.infosPage.name_module ===
        Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES;
      const compSco =
        this.infosPage.name_module ===
        Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES;
      const canEditPro = this.$can('comppro_edit');
      const canEditSco = this.$can('compsco_edit');

      if (isBeneficiary) return false;

      if (compPro) return canEditPro;

      if (compSco) return canEditSco;

      return false;
    },

    currentModule() {
      return this.listModulesPages.filter(
        (m) => m.id === this.infosPage.id_module
      )[0];
    },

    evaluator() {
      if (this.contentHistoryEvaluation?.referent) {
        if (
          this.contentHistoryEvaluation?.referent?.role ===
          this.constants.ROLE_BENEFICIAIRE
        ) {
          return `${this.contentHistoryEvaluation.referent?.firstname} ${this.contentHistoryEvaluation.referent.lastname}`;
        }
        return this.contentHistoryEvaluation.company_name;
      }

      return 'Pas d\'évaluateur sauvegardé';
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
